module.exports = require("./hyphen.js");



//////////////////
// WEBPACK FOOTER
// ./~/hyphen/index.js
// module id = 810
// module chunks = 0